<template>
  <div>
    <v-dialog v-model="dialog" width="75%">
      <v-card>
        <v-card-title class="mx-3">
          <span class="headline">{{
            $t("MovePositionOrder.StockBatchDialog.title")
          }}</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense align="center">
              <v-col cols="12" sm="5" md="6">
                <SearcherKeyword
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchCodeSearch'
                    )
                  "
                  v-model="seacherStockBatchCodeKeyword"
                  @text="stockBatchCodeKeyword = $event"
                />
              </v-col>
              <v-col cols="12" sm="5" md="4">
                <!-- 状态 -->
                <SearcherStatus
                  v-model="stockBatchStatus"
                  :items="$consts.expiredFlgs"
                  :label="
                    $t(
                      'MovePositionOrder.StockBatchDialog.stockBatchStatusSearch'
                    )
                  "
                />
              </v-col>
              <v-col cols="3" sm="2" md="2">
                <v-tooltip>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      class="px-0 py-0 caption font-weight-bold grey--text"
                      color="primary"
                      @click.stop="onSearch()"
                    >
                      <v-icon small class="pe-1">fa-search</v-icon>
                      {{ $t("Search.search") }}
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-data-table
              :headers="stockBatchHeaders"
              :items="searchStockBatchs.length ? searchStockBatchs : stockBatch"
              :loading="loading"
              multi-sort
              disable-pagination
              hide-default-footer
              class="elevation-0 px-6"
              fixed-header
              height="360px"
              v-model="showSelected"
              show-select
            >
              <template v-slot:item.stock_detail.stock_batch_code="{ item }">
                {{ item.stock_detail.stock_batch_code }}
                <v-chip
                  v-if="item.stock_detail.expired_flg"
                  x-small
                  label
                  :color="item.stock_detail.expired_flg | expiredFlgsColor"
                  :text-color="
                    item.stock_detail.expired_flg | expiredFlgsTextColor
                  "
                >
                  {{ item.stock_detail.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.stock_detail.prohibit_flg"
                  small
                  label
                  :color="item.stock_detail.prohibit_flg | prohibitFlgsColor"
                  :text-color="
                    item.stock_detail.prohibit_flg | prohibitFlgsTextColor
                  "
                >
                  {{ item.stock_detail.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </template>
              <template v-slot:item.stock_detail.production_date="{ item }">
                {{ item.stock_detail.production_date | formatDate }}
              </template>
              <template v-slot:item.stock_detail.expired_date="{ item }">
                {{ item.stock_detail.expired_date | formatDate }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="dialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="submit()">
            {{ $t("StockContainers.selectContainer.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";

export default {
  name: "SelectStockBatchDialog",

  props: {
    value: Boolean,
    label: String,
    stockBatch: Array,
    cancelMode: Boolean,
  },

  components: {
    SearcherKeyword,
    SearcherStatus,
  },

  computed: {
    //搜索
    searchData() {
      var stockBatch = [];
      var option = [];
      this.stockBatch.filter((batch) => {
        //过期状态
        if (this.stockBatchStatus.length) {
          option.status = this.stockBatchStatus;
        } else {
          option.status = [0, 1];
        }
        //批次号
        if (this.stockBatchCodeKeyword) {
          option.keyword = this.stockBatchCodeKeyword;
        }
        if (option.keyword) {
          if (
            option.status.indexOf(batch.stock_detail.expired_flg) != -1 &&
            batch.stock_detail.stock_batch_code.indexOf(option.keyword) != -1
          ) {
            stockBatch.push(batch);
          }
        } else if (
          option.status.indexOf(batch.stock_detail.expired_flg) != -1
        ) {
          stockBatch.push(batch);
        }
      });
      return stockBatch;
    },

    stockBatchHeaders() {
      return [
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.material"
          ),
          align: "center",
          sortable: false,
          value: "material_description",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.position"
          ),
          align: "center",
          sortable: false,
          value: "position_description",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.stock_batch_code"
          ),
          align: "center",
          sortable: false,
          value: "stock_detail.stock_batch_code",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.production_date"
          ),
          align: "center",
          sortable: false,
          value: "stock_detail.production_date",
        },
        {
          text: i18n.t(
            "MovePositionOrder.StockBatchDialog.DetailFieds.expired_date"
          ),
          align: "center",
          sortable: false,
          value: "stock_detail.expired_date",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    dialog: false,
    stockPositionBatchs: [],
    seacherStockBatchCodeKeyword: "",
    stockBatchCodeKeyword: "",
    stockBatchStatus: [0, 1],
    showSelected: [],
    searchStockBatchs: [],
  }),

  methods: {
    onSearch() {
      var stockBatch = [];
      var option = [];
      this.stockBatch.filter((batch) => {
        //过期状态
        if (this.stockBatchStatus.length) {
          option.status = this.stockBatchStatus;
        } else {
          option.status = [0, 1];
        }
        //批次号
        if (this.stockBatchCodeKeyword) {
          option.keyword = this.stockBatchCodeKeyword;
        }
        if (option.keyword) {
          if (
            option.status.indexOf(batch.stock_detail.expired_flg) != -1 &&
            batch.stock_detail.stock_batch_code.indexOf(option.keyword) != -1
          ) {
            stockBatch.push(batch);
          }
        } else if (
          option.status.indexOf(batch.stock_detail.expired_flg) != -1
        ) {
          stockBatch.push(batch);
        }
      });

      this.searchStockBatchs = stockBatch;
    },
    submit() {
      var showSelectedId = [];
      this.showSelected.map((selected) => {
        showSelectedId.push(selected.id);
      });
      this.$emit("stockBatchSeleted", this.showSelected);
      this.dialog = false;
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.showSelected = [];
        }
      },
    },
    stockBatchStatus: {
      handler() {
        this.onSearch();
      },
    },
    seacherStockBatchCodeKeyword: {
      handler() {
        this.stockBatchCodeKeyword = this.seacherStockBatchCodeKeyword;
        this.onSearch();
      },
    },
    stockBatch: {
      handler() {
        this.stockBatch.forEach((batch) => {
          if (
            new Date(batch.stock_detail.expired_date).getTime() <
            new Date().getTime()
          ) {
            batch.stock_detail.expired_flg = 1;
          } else {
            batch.stock_detail.expired_flg = 0;
          }
        });
      },
    },
  },
};
</script>